import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import sessionsActions from '../devise/sessions/actions'

const LogoutPage = ({ dispatch, loggingStatus = 'idle' }) => {
  const { t } = useTranslation('LogoutPage')

  if (loggingStatus !== 'logout') {
    dispatch(sessionsActions.logout())
  }

  return (
    <div className="d-flex flex-column flex-fill justify-content-center align-items-center">
      {t('message')}
    </div>
  )
}

LogoutPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loggingStatus: PropTypes.string
}

const mapStateToProps = ({
  authentication: {
    loggingStatus
  }
}) => ({
  loggingStatus
})

export default connect(mapStateToProps)(LogoutPage)
